/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Choose/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import ImageSelect from './ImageSelect/index'
import React from 'react'
import SwitchImages from './SwitchImages/index'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Choose({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Comparison/Content/Content/Actions/Choose"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<SwitchImages
  viewPath={`${viewPath}/SwitchImages`}
/>
<div
  data-testid="Choose.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="secondary"
 size="normal"
 text="Choose image"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'ImageSelect/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'ImageSelect/Content'))}
/>
</div>
<ImageSelect
  viewPath={`${viewPath}/ImageSelect`}
/>
{children}
</React.Fragment>)
}